import config from "../constants/Config";

export const formatCurrency = (amount: any, hideCurrency = false, decimals: number = 2): any => {
  if (isNaN(amount)) return false

  let options: any = {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }

  if (hideCurrency) {
    options = {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }
  }

  // this ain't working for native
  // return new Intl.NumberFormat('en-NG', options).format(amount) 
  
  if (!amount) {
    amount = 0;
  }

  const hasDecimal = decimals > 0
  const hasSymbol = !hideCurrency

  // https://www.wikitechy.com/tutorials/javascript/print-a-number-with-commas-as-thousands-separators-in-javascript
  function thousands_separators(num: string) {
    var num_parts = hasDecimal ? parseFloat(num).toFixed(2).split(".") : num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // use decimal?
    if (hasDecimal) return num_parts.join(".");
    return num_parts[0];
  }
  return `${hasSymbol ? config.currencySymbol + " " : ""}${thousands_separators(
    amount.toString()
  )}`;
}
